import { render } from "./SlackMessageEditor.vue?vue&type=template&id=9d5e9fc4"
import script from "./SlackMessageEditor.vue?vue&type=script&lang=js"
export * from "./SlackMessageEditor.vue?vue&type=script&lang=js"

import "./SlackMessageEditor.vue?vue&type=style&index=0&id=9d5e9fc4&lang=css"

import exportComponent from "/home/forge/staging.ordinocrm.com/releases/20260610000542/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__